export default [
    {
        path: '/product',
        name: 'product',
        component: () => import('@/views/menu/product/product.vue'),
        meta: {
            pageTitle: 'مدیریت محصول ها',
            action: 'show',
            resource: 'ProductManager',
        },
    },
    {
        path: '/product/details',
        name: 'addproduct',
        component: () => import('@/views/menu/product/productdetails.vue'),
        meta: {
            pageTitle: 'ایجاد محصول',
            action: 'show',
            resource: 'ProductManager',
        },
    },
    {
        path: '/product/details/:id',
        name: 'updateproduct',
        component: () => import('@/views/menu/product/productdetails.vue'),
        meta: {
            pageTitle: 'ویرایش محصول',
            action: 'show',
            resource: 'ProductManager',
        },
    },
    {
        path: '/productcategory',
        name: 'productcategory',
        component: () => import('@/views/menu/product/productcategory.vue'),
        meta: {
            pageTitle: 'مدیریت دسته بندی های محصول',
            action: 'show',
            resource: 'ProductCategoryManager',
        },
    },
    {
        path: '/productcategory/details',
        name: 'addproductcategory',
        component: () => import('@/views/menu/product/productcategorydetails.vue'),
        meta: {
            pageTitle: 'ایجاد دسته بندی محصول',
            action: 'show',
            resource: 'ProductCategoryManager',
        },
    },
    {
        path: '/productcategory/details/:id',
        name: 'updateproductcategory',
        component: () => import('@/views/menu/product/productcategorydetails.vue'),
        meta: {
            pageTitle: 'ویرایش دسته بندی محصول',
            action: 'show',
            resource: 'ProductCategoryManager',
        },
    },
    {
        path: '/brand',
        name: 'brand',
        component: () => import('@/views/menu/product/brand.vue'),
        meta: {
            pageTitle: 'مدیریت برندها',
            action: 'show',
            resource: 'BrandManager',
        },
    },
    {
        path: '/brand/details',
        name: 'addbrand',
        component: () => import('@/views/menu/product/branddetails.vue'),
        meta: {
            pageTitle: 'ایجاد برند',
            action: 'show',
            resource: 'BrandManager',
        },
    },
    {
        path: '/brand/details/:id',
        name: 'updatebrand',
        component: () => import('@/views/menu/product/branddetails.vue'),
        meta: {
            pageTitle: 'ویرایش برند',
            action: 'show',
            resource: 'BrandManager',
        },
    },
    {
        path: '/guaranty',
        name: 'guaranty',
        component: () => import('@/views/menu/product/guaranty.vue'),
        meta: {
            pageTitle: 'مدیریت گارانتی ها',
            action: 'show',
            resource: 'GuarantyManager',
        },
    },
    {
        path: '/guaranty/details',
        name: 'addguaranty',
        component: () => import('@/views/menu/product/guarantydetails.vue'),
        meta: {
            pageTitle: 'ایجاد گارانتی',
            action: 'show',
            resource: 'GuarantyManager',
        },
    },
    {
        path: '/guaranty/details/:id',
        name: 'updateguaranty',
        component: () => import('@/views/menu/product/guarantydetails.vue'),
        meta: {
            pageTitle: 'ویرایش گارانتی',
            action: 'show',
            resource: 'GuarantyManager',
        },
    },
    {
        path: '/color',
        name: 'color',
        component: () => import('@/views/menu/product/color.vue'),
        meta: {
            pageTitle: 'مدیریت رنگ ها',
            action: 'show',
            resource: 'ColorManager',
        },
    },
    {
        path: '/productcolor/details',
        name: 'addproductcolor',
        component: () => import('@/views/menu/product/productcolordetails.vue'),
        meta: {
            pageTitle: 'ایجاد رنگ محصول',
            action: 'show',
            resource: 'ProductManager',
        },
    },
    {
        path: '/productcolor/details/:id',
        name: 'updateproductcolor',
        component: () => import('@/views/menu/product/productcolordetails.vue'),
        meta: {
            pageTitle: 'ویرایش رنگ محصول',
            action: 'show',
            resource: 'ProductManager',
        },
    },
]
